export default __webpack_public_path__ + "static/O0111-bcf3fa8cf4ffc9b2aa08e684ffff688b.png";